import { Injectable } from '@angular/core';
import { AssignmentRuleInput } from '../../models/common/assigmentRules/assignmentRuleInput';
import { ToastService } from '../utils/toast.service';
import { TranslatorService } from '../utils/translator.service';

@Injectable()
export class CreateAssignmentRulesService {

    assignmentRules = [];

    constructor(
        private readonly translatorService: TranslatorService,
        private readonly toasterService: ToastService,
    ) { }

    generateRule(ruleName, users, positiveRule, isActive, types?, dealers?, channels?, brands?, origins?, postalCodes?) {
        this.assignmentRules = [];

        users = users ? users.length === 0 ? [null] : users : [null];
        types = types ? types.length === 0 ? [null] : types : [null];
        dealers = dealers ? dealers.length === 0 ? [null] : dealers : [null];
        channels = channels ? channels.length === 0 ? [null] : channels : [null];
        brands = brands ? brands.length === 0 ? [null] : brands : [null];
        origins = origins ? origins.length === 0 ? [null] : origins : [null];
        postalCodes = postalCodes ? postalCodes.length === 0 ? [null] : postalCodes : [null];

        const itemsSelecteds = [users, types, dealers, channels, brands, origins, postalCodes];

        const cartesianOfItemsSelecteds = this.cartesian(itemsSelecteds);

        cartesianOfItemsSelecteds.forEach(cartesian => {
            this.buildAssignmentRuleInLoop(ruleName,
                cartesian[0],
                isActive,
                positiveRule,
                cartesian[1],
                cartesian[2],
                cartesian[3],
                cartesian[4],
                cartesian[5],
                cartesian[6]);
        });

        if (this.assignmentRules.length > 300) {
            this.toasterService
                .showToast(
                    'error',
                    this.translatorService.trans('toasts.create_rules.too_many_rows.title'),
                    this.translatorService.trans('toasts.create_rules.too_many_rows.body')
                        .replace('REPLACE_THIS', `${this.assignmentRules.length}`),
                );

            return [];
        } else {
            return this.assignmentRules;
        }
    }

    cartesian(args) {
        const r = [];
        const max = args.length - 1;
        function helper(arr, i) {
            for (let j = 0, l = args[i].length; j < l; j++) {
                const a = arr.slice(0);
                a.push(args[i][j]);
                if (i === max) {
                    r.push(a);
                } else {
                    helper(a, i + 1);
                }
            }
        }
        helper([], 0);
        return r;
    }

    private buildAssignmentRuleInLoop(ruleName, user, isActive, positiveRule, type: any, dealer: any, channel: any, brand: any, origin: any, postalCode) {
        const assignmentRule = new AssignmentRuleInput();

        assignmentRule.user = user ? user.id : null;
        assignmentRule.assignmentRuleName = ruleName;
        assignmentRule.isActive = isActive;
        assignmentRule.positiveRule = positiveRule;
        assignmentRule.leadType = type ? type.id : null;
        assignmentRule.dealer = dealer ? dealer.id : null;
        assignmentRule.channel = channel ? channel.id : null;
        assignmentRule.brand = brand ? brand.id : null;
        assignmentRule.origin = origin ? origin : null;
        assignmentRule.postalCode = postalCode ? postalCode : null;
        this.assignmentRules.push(assignmentRule);
    }
}
